<template>
  <div class="sh-page">
    <div class="sh-page__glow sh-page__glow--one" aria-hidden="true"></div>

    <div class="sh-card">
      <div class="sh-card__head">
        <LogoTile :branding="branding" :alt="tenantName" :size="44" />
        <span class="noaccess__badge"><v-icon size="20" color="warning">block</v-icon></span>
        <h1 class="sh-card__title">No access to {{ tenantName }}</h1>
        <p class="sh-card__subtitle">
          Your account is signed in, but it is not part of this app. Ask an administrator to add your organisation.
        </p>
      </div>
      <v-btn color="primary" variant="outlined" block @click="session.signOut()">Sign out</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useSessionStore } from "@/stores/session";
import LogoTile from "@/shell/LogoTile.vue";

export default defineComponent({
  name: "NoAccess",
  components: { LogoTile },
  setup() {
    const session = useSessionStore();
    const tenantName = computed(() => session.tenant?.name || "Metaship");
    const branding = computed(() => session.tenant?.branding ?? null);
    return { session, tenantName, branding };
  },
});
</script>

<style scoped>
.noaccess__badge {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(var(--v-theme-warning), 0.14);
}
</style>
